import { jsx as e } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as c } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import u from "classnames";
import f from "../../../../../core/Context/useCoreContext.js";
import y from "../../../../../hooks/useTimezoneAwareDateFormatting.js";
import i from "../../../../internal/Typography/Typography.js";
import { TypographyVariant as n, TypographyElement as d } from "../../../../internal/Typography/types.js";
import { Tag as A } from "../../../../internal/Tag/Tag.js";
import { GRANT_ITEM_CLASS_NAMES as o } from "./constants.js";
import { getGrantConfig as v } from "./utils.js";
/* empty css               */
import { GrantDetails as h } from "../GrantDetails/GrantDetails.js";
import { GrantAction as C } from "../GrantAction/GrantAction.js";
import N from "../../../../internal/CopyText/CopyText.js";
import { Tooltip as I } from "../../../../internal/Tooltip/Tooltip.js";
import { Alert as x } from "../../../../internal/Alert/Alert.js";
import { AlertTypeOption as b } from "../../../../internal/Alert/types.js";
import E from "../../../../internal/ExpandableCard/ExpandableCard.js";
import { Fragment as T } from "../../../../../external/preact/dist/preact.module.js";
import S from "../../../../internal/ProgressBar/ProgressBar.js";
import { DATE_FORMAT_CAPITAL_OVERVIEW as L } from "../../../../../constants/dateFormats.js";
const Q = ({ grant: r }) => {
  const { i18n: a } = f(), { dateFormat: s } = y(), t = c(() => v(r), [r]), g = c(
    () => {
      var m, l;
      return /* @__PURE__ */ e("div", { className: o.cardContent, children: [
        /* @__PURE__ */ e("div", { className: o.statusContainer, children: [
          /* @__PURE__ */ e(
            i,
            {
              variant: n.CAPTION,
              className: u({ [o.textSecondary]: t.isLabelColorSecondary }),
              testId: "grant-amount-label",
              children: a.get(t.amountLabelKey)
            }
          ),
          /* @__PURE__ */ e("div", { children: r.status === "Active" ? /* @__PURE__ */ e(T, { children: [
            /* @__PURE__ */ e(i, { variant: n.CAPTION, el: d.SPAN, children: a.get("capital.termEnds") }),
            /* @__PURE__ */ e(i, { variant: n.CAPTION, stronger: !0, el: d.SPAN, children: s(t.repaymentPeriodEndDate, L) })
          ] }) : t.statusKey ? t.statusTooltipKey ? /* @__PURE__ */ e(I, { content: a.get(t.statusTooltipKey), children: /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(A, { label: a.get(t.statusKey), variant: t.statusTagVariant }) }) }) : /* @__PURE__ */ e(A, { label: a.get(t.statusKey), variant: t.statusTagVariant }) : null })
        ] }),
        /* @__PURE__ */ e(
          i,
          {
            variant: n.TITLE,
            medium: !0,
            className: u({
              [o.textSecondary]: t.isAmountColorSecondary
            }),
            children: a.amount(t.amount.value, t.amount.currency)
          }
        ),
        t.isProgressBarVisible && /* @__PURE__ */ e(
          S,
          {
            className: o.progressBar,
            value: r.repaidTotalAmount.value,
            max: r.totalAmount.value,
            labels: { current: a.get("capital.repaid"), max: a.get("capital.remaining") },
            tooltips: {
              remaining: `${a.amount(r.remainingTotalAmount.value, r.remainingTotalAmount.currency)} ${(m = a.get("capital.remaining")) == null ? void 0 : m.toLowerCase()}`,
              progress: `${a.amount(r.repaidTotalAmount.value, r.repaidTotalAmount.currency)} ${(l = a.get("capital.repaid")) == null ? void 0 : l.toLowerCase()}`
            }
          }
        ),
        t.isGrantIdVisible ? /* @__PURE__ */ e("div", { className: o.grantID, children: /* @__PURE__ */ e(N, { textToCopy: r.id, buttonLabel: a.get("capital.grantID"), isHovered: !0, type: "Text" }) }) : null,
        t.hasAlerts && /* @__PURE__ */ e(T, { children: r.missingActions && r.missingActions.length ? r.missingActions.map((p) => /* @__PURE__ */ e(
          C,
          {
            action: p,
            className: o.alert,
            offerExpiresAt: r.offerExpiresAt
          },
          p.type
        )) : /* @__PURE__ */ e(
          x,
          {
            className: o.alert,
            type: b.HIGHLIGHT,
            title: a.get("capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon")
          }
        ) })
      ] });
    },
    [a, s, r, t]
  );
  return /* @__PURE__ */ e("div", { className: o.base, children: /* @__PURE__ */ e(E, { renderHeader: g, filled: t.isBackgroundFilled, inFlow: !0, children: t.hasDetails && /* @__PURE__ */ e(h, { grant: r }) }) });
};
export {
  Q as GrantItem
};
